//import '@babel/polyfill';
import { tns } from 'tiny-slider/src/tiny-slider';
import showScroll from './modules/showScroll'

// Import SASS
import '../sass/style.scss'


//import "core-js/es6";
//import "regenerator-runtime/runtime";

// Node_modules
import objectFitImages from 'object-fit-images'

import modals from './modules/modals.js';
import '../partials/navigation/menus/menus';
// Import scripts
import './modules/skip-link-focus-fix'
import initYoutubeVideos from './modules/init-after-youtube-api' // when videos are loaded on the page

//import '../partials/navigation/menus/menus'//
import '../partials/search/search'
import initSliders from '../partials/sliders/sliders'
// import { initBlockSlider } from '../partials/blocks/block/block-slider'

import gsap from "gsap";

import mixitup from 'mixitup';

import cookieModal from './modules/cookie';


function newsFilter() {

  if (document.querySelector(".news__wrapper")) { 
    var mixer = mixitup('.news__wrapper');
  }
}







window.onYouTubeIframeAPIReady = function() {
	initYoutubeVideos();
}

// Object-fit fix
objectFitImages()

/*

function init() {


  document.getElementById("slide-down").addEventListener("click",(e)=>{
      e.preventDefault();
      const element = document.getElementById('continue');
      element.scrollIntoView({ block: 'begin',  behavior: 'smooth' });
  });

}

*/

// tell Barba to use the css plugin
function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}    


docReady(function() {

    let sliders = initSliders();
    showScroll('.scroll-top');
    console.log(sliders);

});

modals.init( {
  backspaceClose: false,
  callbackOpen: function ( toggle, modal ) {


    var modal = document.querySelector("#" + modal.id);


    modal.classList.add("fadeInUp");
    modal.classList.add("animated");
    modal.classList.add("active");

  }

} );

document.querySelectorAll('.open-contact').forEach(function(element) {
  element.addEventListener('click', function() {
    modals.openModal( null, '#modal-contact' );
  });
});

document.querySelectorAll('.open-download').forEach(function(element) {
  element.addEventListener('click', function() {
    modals.openModal( null, '#modal-download' );
  });
});

if (document.getElementById('field_29_16')) {    
    const fieldset = document.getElementById('field_29_16');
    const radios = fieldset.querySelectorAll('input[type="radio"]');
    const targetElement = document.getElementById('field_29_17');

    radios.forEach(radio => {
      radio.addEventListener('click', () => {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      });
    });
}